module.exports = __webpack_public_path__ + "media/images/flavours/icon-balsamique_dark-9b35e1b6351e14004dbae9cc6efc7b83.png";